
import moment from 'moment';

import React, { Component } from 'react';
import { SelectButtonGroupWidget } from 'form/SelectButtonGroupWidget';
import { DateDayWidget } from 'form/new/DateDayWidget';
import CachedIcon from '@material-ui/icons/Cached';
import {IconButton} from '@material-ui/core';


export class TimetableListFilter extends Component {

  componentDidMount() {
    const { context } = this.props;
    const { filter, setFilterValue } = context;
    if (!filter.date_start) {
      setFilterValue('date_start', moment().format('YYYY-MM-DD'));
    }
  }

  render() {
    const { context } = this.props;
    const { filter, loading, setFilterValue } = context;

    return (
      <>
        <DateDayWidget
          value={filter.date_start}
          onChange={(value, stringValue) => setFilterValue('date_start', stringValue)}
          size={'small'}
        />
        <SelectButtonGroupWidget
          value={filter.days}
          onChange={(value) => setFilterValue('days', value)}
          options={[
            {label: '1 день', value: null},
            {label: '2 дня', value: 2},
            {label: '3 дня', value: 3},
          ]}
        />
        <IconButton
          disabled={loading}
          variant="outlined"
          size={'small'}
          onClick={() => context.setPageNumber(1)}
        >
          <CachedIcon />
        </IconButton>
      </>
    )
  }
}
